import { memo } from 'react';

import type { LbPart } from '../../types';

const Composer = ({ part: { data } }: { part: LbPart }) =>
  data.imgUrl ? (
    <div className='lb-composer-wrap'>
      <img src={data.imgUrl} className='lb-free-image' />
    </div>
  ) : (
    <div className='lb-composer-wrap' dangerouslySetInnerHTML={{ __html: data.Text }} />
  );

export default memo(Composer);
